import { Step } from "react-joyride";
import {
  ADDITIONAL_RECIPIENTS_STEP,
  EMAIL_SETTINGS_STEP,
  MAIN_RECIPIENT_STEP,
  PROPOSAL_FORMAT_STEP,
} from "./draftTourContent";

const confirmProposalModalTourSteps: Step[] = [
  {
    ...PROPOSAL_FORMAT_STEP,
    placement: "left",
  },
  MAIN_RECIPIENT_STEP,
  ADDITIONAL_RECIPIENTS_STEP,
  EMAIL_SETTINGS_STEP,
];

export default confirmProposalModalTourSteps;
